class LocalisationModal extends HTMLElement {
  constructor() {
    super();

    this.localisation = window.localisation;
    this.languageSelector = this.querySelector('#language-selector');
    this.countrySelector = this.querySelector('#country-selector');
    this.submit = this.querySelector('#submit-button');
    this.continueButton = this.querySelector('#continue-button');

    this.modalVisible = false;

    this.tryAutoRedirectOnce();
  }

  connectedCallback() {
    this.body = document.querySelector('body');

    const close = this.querySelectorAll('.close-button');

    close.forEach((item) => {
      item.addEventListener('click', this.close.bind(this));
    });

    this.currentLanguage = this.dataset.currentLanguage;

    let countryCode = this.countrySelector.options[this.countrySelector.selectedIndex].dataset.country;
    this.updateLanguageSelector(countryCode);

    this.countrySelector.addEventListener('change', this.changeLanguage.bind(this));
    this.submit.addEventListener('click', this.onSubmit.bind(this));
    if (this.continueButton) this.continueButton.addEventListener('click', this.onSubmit.bind(this));
  }

  open() {
    this.classList.remove('tw-invisible');
    this.classList.remove('tw-opacity-0');
    this.classList.add('tw-visible');
    this.classList.add('tw-opacity-100');
  }

  close() {
    this.classList.remove('tw-visible');
    this.classList.remove('tw-opacity-100');
    this.classList.add('tw-opacity-0');
    this.classList.add('tw-invisible');
  }

  changeLanguage() {
    let countryCode = this.countrySelector.options[this.countrySelector.selectedIndex].dataset.country;
    this.updateLanguageSelector(countryCode);
  }

  updateLanguageSelector(countryCode) {
    let localisation = this.localisation[countryCode] || '';

    if (localisation) {
      this.languageSelector.classList.remove('tw-hidden');
      this.languageSelector.innerHTML = localisation;

      // Pre-select the current language if available in this country's options
      if (this.currentLanguage) {
        const match = this.languageSelector.querySelector(`option[value="${this.currentLanguage}"]`);
        if (match) match.selected = true;
      }
    } else {
      this.languageSelector.classList.add('tw-hidden');
      this.languageSelector.innerHTML = '';
    }
  }

  onSubmit(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const currentCountry = this.dataset.currentCountry;
    const requestCountry = this.dataset.requestCountry;
    try {
      if (this.countrySelector && this.countrySelector.value) {
        // Mark a pending manual selection to prevent bounce on next load
        window.sessionStorage.setItem('localisationPendingCountry', this.countrySelector.value);
        window.localStorage.setItem('localisationCountry', this.countrySelector.value);
        window.sessionStorage.setItem('localisationUserOverride', 'true');
      }
      window.localStorage.setItem('localisationPopup', 'true');
    } catch (e) {}
    try {
      const selected = this.countrySelector && this.countrySelector.value;
      const ipCountry = window.sessionStorage.getItem('localisationIPCountry');
      if (this.countrySelector && selected === currentCountry) {
        const target = requestCountry && requestCountry !== currentCountry ? requestCountry : ipCountry;
        if (target && target !== currentCountry) {
          this.countrySelector.value = target;
          window.sessionStorage.setItem('localisationPendingCountry', target);
          window.localStorage.setItem('localisationCountry', target);
        }
      }
    } catch (e) {}
    if (form) form.submit();
  }

  tryAutoRedirectOnce() {
    try {
      if (['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)) return;

      const requestCountry = this.dataset.requestCountry;
      const currentCountry = this.dataset.currentCountry;
      const storedCountryLocal = window.localStorage.getItem('localisationCountry');
      const pendingCountry = window.sessionStorage.getItem('localisationPendingCountry');
      const storedCountry = pendingCountry || storedCountryLocal;
      const userOverride = window.sessionStorage.getItem('localisationUserOverride') === 'true';
      const autoRedirectFlagStored = 'localisationAutoRedirectedStored';
      const autoRedirectFlagRequest = 'localisationAutoRedirectedRequest';
      const autoRedirectFlagIP = 'localisationAutoRedirectedIP';

      if (!currentCountry) return;

      // Always honor the most recently chosen country on every page load
      if (storedCountry && storedCountry !== currentCountry) {
        this.redirectToMarket(storedCountry);
        try {
          window.sessionStorage.removeItem('localisationPendingCountry');
        } catch (e) {}
        return;
      }

      const shouldSkipIP = !!storedCountry || userOverride;
      (shouldSkipIP ? Promise.resolve('') : this.detectCountryByIP())
        .then((ipCountry) => {
          if (
            ipCountry &&
            ipCountry !== currentCountry &&
            (!requestCountry || ipCountry !== requestCountry) &&
            !window.sessionStorage.getItem(autoRedirectFlagIP)
          ) {
            window.sessionStorage.setItem(autoRedirectFlagIP, 'true');
            try {
              window.sessionStorage.removeItem(autoRedirectFlagStored);
            } catch (e) {}
            try {
              window.sessionStorage.removeItem(autoRedirectFlagRequest);
            } catch (e) {}
            this.redirectToMarket(ipCountry);
            return true;
          }
          return false;
        })
        .then((redirected) => {
          if (redirected) return;
          if (
            requestCountry &&
            requestCountry !== currentCountry &&
            !window.sessionStorage.getItem(autoRedirectFlagRequest)
          ) {
            window.sessionStorage.setItem(autoRedirectFlagRequest, 'true');
            try {
              window.sessionStorage.removeItem(autoRedirectFlagStored);
            } catch (e) {}
            try {
              window.sessionStorage.removeItem(autoRedirectFlagIP);
            } catch (e) {}
            this.redirectToMarket(requestCountry);
            return;
          }
          const acknowledged = !!window.localStorage.getItem('localisationPopup');
          const shouldPrompt =
            (storedCountry && storedCountry !== currentCountry) ||
            (requestCountry && requestCountry !== currentCountry);

          if (!acknowledged && shouldPrompt) {
            this.open();
          } else if (!acknowledged) {
            try {
              window.localStorage.setItem('localisationPopup', 'true');
              this.setCookie('localisationPopup', 'true', 365);
            } catch (e) {}
          }
        })
        .catch(() => {
          const acknowledged = !!window.localStorage.getItem('localisationPopup');
          const shouldPrompt =
            (storedCountry && storedCountry !== currentCountry) ||
            (requestCountry && requestCountry !== currentCountry);
          if (!acknowledged && shouldPrompt) {
            this.open();
          } else if (!acknowledged) {
            try {
              window.localStorage.setItem('localisationPopup', 'true');
            } catch (e) {}
          }
        });
    } catch (e) {
      // If anything fails, gracefully show the modal only if not previously acknowledged
      const acknowledged = !!window.localStorage.getItem('localisationPopup');
      const requestCountry = this.dataset.requestCountry;
      const currentCountry = this.dataset.currentCountry;
      const storedCountryLocal = window.localStorage.getItem('localisationCountry');
      const storedCountry = storedCountryLocal;
      const shouldPrompt =
        (storedCountry && storedCountry !== currentCountry) || (requestCountry && requestCountry !== currentCountry);
      if (!acknowledged && shouldPrompt) {
        this.open();
      } else if (!acknowledged) {
        try {
          window.localStorage.setItem('localisationPopup', 'true');
        } catch (err) {}
      }
    }
  }

  detectCountryByIP() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 1200);
    return fetch('https://ipapi.co/country/', { signal: controller.signal })
      .then((res) => (res.ok ? res.text() : ''))
      .then((text) => {
        const code = text.trim().toUpperCase();
        try {
          if (code) window.sessionStorage.setItem('localisationIPCountry', code);
        } catch (e) {}
        return code;
      })
      .catch(() => '')
      .finally(() => clearTimeout(timeout));
  }

  redirectToMarket(countryCode) {
    try {
      if (!countryCode || !this.countrySelector) return;
      this.countrySelector.value = countryCode;
      // Clear locale so auto-redirects only change the country and let
      // Shopify pick the target market's default language.
      if (this.languageSelector) this.languageSelector.innerHTML = '';
      const form = this.querySelector('form');
      if (form) {
        // Persist selection on redirect so subsequent loads are consistent
        try {
          window.localStorage.setItem('localisationCountry', countryCode);
        } catch (e) {}
        form.submit();
      }
    } catch (e) {}
  }
}

customElements.define('localisation-modal', LocalisationModal);

class LocalisationOpen extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      const modal = document.querySelector('localisation-modal');
      if (modal) modal.open();
    });
  }
}

customElements.define('localisation-open', LocalisationOpen);
